export const BLOG_CATEGORIES = {
  national: [
    'National Issues',
    'These issues fall under the purview of Congress and/or the President.',
  ],
  resistbot: [
    'Resistbot Features and Releases',
    'Stay up-to-date on the newest bot features and our organization.',
  ],
  state: [
    'State Issues',
    'Your Governor and state legislators have the power here, engage with them to make a difference.',
  ],
  podcast: [
    'Resistbot Live',
    'Join us as we explore the issues that matter to the users of Resistbot and learn from the experts about why these issues are important to you too.',
  ],
};
